/**
 * Returns array as a formatted string with custom standard and final separators
 * @param list
 * @param customSeparator
 * @param customFinalSeparator
 */

export function formatList(
  list: readonly string[],
  customSeparator: string | null = null,
  customFinalSeparator: string | null = null,
): string {

  if (list.length === 0) {
    return ''
  }

  const standardSeparator = customSeparator ?? ', '
  const finalSeparator = customFinalSeparator ?? ' or '

  const formatListReducer = (formattedList: string, currentElement: string, currentIndex: number) => {

    let separator: string
    if (currentIndex === 0) {
        // Current element is the first in the list
      separator = ''
    } else if (currentIndex === list.length - 1) {
        //Current element is the last in the list
      separator = finalSeparator
    } else {
      separator = standardSeparator
    }

    return formattedList
      .concat(separator, currentElement.replace(' ', '\xa0'))
  }

  return list.reduce<string>(formatListReducer, '')
}